module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 24\".468eb74d.png";